'use client';

import { Component } from '@/shared';
import { Session } from "next-auth";
import { signIn } from "next-auth/react";
import { getClasses } from "@/classes";

export interface LoginComponent extends Component {
  label: string,
}

function checkLoginComponent(component: Component): LoginComponent {
  const { label, ...props } = component as LoginComponent;

  if (!label) {
    throw new Error(`no label in login component`);
  }

  return {
    ...props,
    label,
  };
}

export default function Login({ component, session, }: { component: Component, session: Session | null }) {
  const { label, classes, } = checkLoginComponent(component);

  return !session && (
    <div
      className={getClasses([`login-component`, classes,])}
    >
      <a
        className={`cursor-pointer`}
        onClick={() => signIn()}
      >
        <p>{label}</p>
      </a>
    </div>
  );
}
